<template>
  <div>
    <hr v-if="displayHR" />
    <h4>{{ translations.files }}</h4>
    <div class="files product" v-if="files.product.length">
      <div class="file" v-for="file in files.product" :key="`product_file_${file.file.ID}`">
        <a :href="file.file.link" target="_blank">
          {{ file.filename }}
        </a>
      </div>
    </div>
    <div class="files terms" v-if="Object.keys(files.terms).length">
      <template v-for="termSlug in Object.keys(files.terms)">
        <div
          class="file"
          v-for="file in files.terms[termSlug]"
          :key="`product_term_${termSlug}_file_${file.file.ID}`"
        >
          <a :href="file.file.link" target="_blank">
            {{ file.filename }}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFiles',
  data() {
    return {
      translations: {
        files: ws_vue_store.translations.files,
      },
    };
  },
  props: {
    files: Object,
    displayHR: Boolean,
  },
};
</script>
